<template>
  <div class="Chart">
    
    
    <div :id="'graphdiv_'+data.id" class="graphdiv"></div>
    <div><b>
      <span style="color: #0099FF">1.CW-zasilanie </span>
      <span style="color: #00CC00">2.CW-cyrkulacja </span>
      <span style="color: #FF0000">3.CO-zasilanie </span> 
      <span style="color: #FFCC00">4.CO-cyrkulacja </span>
      <span style="color: #CC66FF">5.Kotły</span></b>
    </div>
  </div>  
</template>

<script>

import Dygraph from 'dygraphs';
//import axios from 'axios'

export default {
  name: 'Chart',
  props: {
    data: Object,
    
  },
  data() {
    return {
      
    }
  },
  mounted () {
    
    
    var objData = {
        id: this.data.id,
        range: 1,

      }
    this.$store.dispatch('getAllData', objData);
  },
  computed: {

    data_chart(){
      
      var obj = {};
      if (this.data.id == 0){
        obj = this.$store.getters.getted_data_0;
      }else if (this.data.id == 1){
        obj = this.$store.getters.getted_data_1;
      }else if (this.data.id == 2){
        obj = this.$store.getters.getted_data_2; 
      }else if (this.data.id == 3){
        obj = this.$store.getters.getted_data_3; 
      }else if (this.data.id == 4){
        obj = this.$store.getters.getted_data_4;   
      }else if (this.data.id == 5){
        obj = this.$store.getters.getted_data_5;  
      }else if (this.data.id == 6){
        obj = this.$store.getters.getted_data_6; 
      }else if (this.data.id == 7){
        obj = this.$store.getters.getted_data_7;  
      }else if (this.data.id == 8){
        obj = this.$store.getters.getted_data_8;
                     
      }
      
      return obj;
    },
  },
  watch: {
    data_chart: function(newData, oldData){
      
       this.buildChart(this.data_chart);
    }
  },
  updated() {
    
    this.buildChart(this.data_chart);
  },
  methods: {
      buildChart(data){
        var valueRange = [0, 75];
        var le = data.data.length;
        if (le > 0){
          var tab = [];
        for (var i = 0; i < le; i++) {
          
          var d = new Date(Date.parse(data.data[i].date));
          var t1 = (parseFloat(data.data[i].t1));
          var t2 = (parseFloat(data.data[i].t2));
          var t3 = (parseFloat(data.data[i].t3));
          var t4 = (parseFloat(data.data[i].t4));
          var t5 = (parseFloat(data.data[i].t5));
          tab.push([d, t1, t2, t3, t4, t5]);
        }
        new Dygraph('graphdiv_'+this.data.id, tab, {
          //legend: 'always'
            valueRange: valueRange,
            ylabel: 'T (C)',
           showRangeSelector: true
          , labels: ['Czas', '1.CW-zasilanie', '2.CW-cyrkulacja', '3.CO-zasilanie', '4.CO-cyrkulacja', '5.Kotły']
          , strokeWidth: 2
          , includeZero:true
          , colors: [
            "#0099FF",
            "#00CC00",
            "#FF0000",
            "#FFCC00",
            "#CC66FF"]
            
        });
        }
        
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .card{
    margin: 10px;
  }
  .graphdiv{
    width: auto;
    height: 250px;
  }
  .dygraph-legend{
    float: right;
    font-size: 9px;
  }
  .dygraph-ylabel{
    
    float:right;
  }
</style>
